import React from 'react';
import { Route, Switch } from 'react-router-dom';
import { getRouteStackPath } from '@portal/config/routes';
import PanelContent from '~/components/PanelContent/PanelContent';
import { translate } from '~/services/i18n';

import Approved from './Approved';
import DetailApproved from './DetailApproved/DetailApproved';

const ApprovedNavigationStack = () => {
  return (
    <Switch>
      <Route exact path={getRouteStackPath('APPROVED', 'APPROVED_PAGE')}>
        <PanelContent
          pageTitle={translate('PAGES.HOME.APPROVED.PAGE_TITLE')}
          pageDescription={translate('PAGES.HOME.APPROVED.PAGE_DESCRIPTION')}
        >
          <Approved />
        </PanelContent>
      </Route>
      <Route exact path={getRouteStackPath('APPROVED', 'APPROVED_DETAIL')}>
        <PanelContent pageTitle={translate('PAGES.HOME.APPROVED.PAGE_TITLE')}>
          <DetailApproved />
        </PanelContent>
      </Route>
    </Switch>
  );
};

export default ApprovedNavigationStack;
